<p-panel>
	<app-reactive-form-builder
		(stableValueChanges)="stableValueChanges($event)"
		(goBack)="goBack()"
		[form]="form.formFields"
		[id]="reactiveFormRecordId"
		[request]="request"
		[getRequest]="productApi.productos.GET"
	>
	</app-reactive-form-builder>
</p-panel>
